import { useCallback } from 'react'
import {
  ApiGetWithToken,
	ApiDeleteWithToken,
	ApiPatchWithToken,
	ApiPostWithToken,
	useApiFetch,
	useApiPost
} from 'shared/api'
import {
  groupApi,
  groupApiBy,
	selfApi
} from 'interface/endpoints'
import {
	GroupFormData,
  GroupResult,
  GroupResultList,
} from './types'

export * from './types'

export const useSelfGroup = (
) => useApiFetch(
	useCallback(
		(apiAccess, cancelToken) => {
      return ApiGetWithToken<GroupResult>(
        apiAccess,
        selfApi('/group'),
        cancelToken
      )
    },
		[]
	)
)

export const useListGroup = (
) => useApiFetch(
	useCallback(
		(apiAccess, cancelToken) => {
      return ApiGetWithToken<GroupResultList>(
        apiAccess,
        groupApi('/list'),
        cancelToken
      )
    },
		[]
	)
)

export const useGetGroup = (
  groupId?: number | null
) => useApiFetch(
	useCallback(
		(apiAccess, cancelToken) => {
      if (!groupId) return null
      return ApiGetWithToken<GroupResult>(
        apiAccess,
        groupApiBy(groupId),
        cancelToken
  		)
    },
		[groupId]
	)
)

export const usePostGroup = (
  callback?: {
    onPosted?: (result: GroupResult) => void
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onError?: (reason: any) => void
  }
) => useApiPost<GroupFormData, GroupResult>(
	useCallback(
		(apiAccess, cancelToken, form, webSocketId) => {
			return ApiPostWithToken(
				apiAccess,
        groupApi(),
				form,
				cancelToken,
				webSocketId
			)
		},
		[]
	),
	useCallback(
		(result) => {
			if (callback?.onPosted) callback.onPosted(result)
			return result
		},
		[callback]
	),
	useCallback(
		(reason) => {
      if (callback?.onError) callback?.onError(reason)
		},
		[callback]
	)
)

export const useEditGroup = (
	groupId: number,
  callback?: {
    onEditted?: (result: GroupResult) => void
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onError?: (reason: any) => void
  }
) => useApiPost<GroupFormData, GroupResult>(
	useCallback(
		(apiAccess, cancelToken, form, webSocketId) => {
			return ApiPatchWithToken(
				apiAccess,
        groupApiBy(groupId),
				form,
				cancelToken,
				webSocketId
			)
		},
		[groupId]
	),
	useCallback(
		(result) => {
			if (callback?.onEditted) callback.onEditted(result)
			return result
		},
		[callback]
	),
	useCallback(
		(reason) => {
      if (callback?.onError) callback?.onError(reason)
		},
		[callback]
	)
)

export const useDeleteGroup = (
  callback?: {
    onDeleted?: (groupId: number) => void
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onError?: (reason: any) => void
  }
) => useApiPost<number, number>(
	useCallback(
		(apiAccess, cancelToken, groupId, webSocketId) => {
			return ApiDeleteWithToken(
				apiAccess,
        groupApiBy(groupId),
				cancelToken,
				webSocketId
			)
		},
		[]
	),
	useCallback(
		(result) => {
			if (callback?.onDeleted) callback.onDeleted(result)
			return result
		},
		[callback]
	),
	useCallback(
		(reason) => {
      if (callback?.onError) callback?.onError(reason)
		},
		[callback]
	)
)

